import { FiltersObject, formatFiltersForSearchParams } from '../utils';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';

interface useFiltersResult {
    setFilters: (filters: FiltersObject) => void;
    clearFilters: () => void;
}

export function useFilters(): useFiltersResult {
    const searchParams = useSearchParams();
    const pathname = usePathname();
    const router = useRouter();

    function setFilters(filters: FiltersObject) {
        const currentParams = new URLSearchParams(searchParams.toString());

        // clear filters before setting new ones to avoid duplicates
        currentParams.delete('filters');

        const filterParams = formatFiltersForSearchParams(filters);
        router.push(
            currentParams.toString() !== ''
                ? `${pathname}?${currentParams}&${filterParams}`
                : `${pathname}?${filterParams}`
        );
    }

    function clearFilters() {
        const currentParams = new URLSearchParams(searchParams.toString());
        currentParams.delete('filters');
        router.push(`${pathname}?${currentParams}`);
    }

    return { setFilters, clearFilters };
}
